import getSymbolFromCurrency from 'currency-symbol-map';

export const dateFormatter = (
  date: Date | string,
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
) => {
  const newDate = new Date(date);

  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(newDate);
  return formattedDate;
};

export const currencyFormatter = (
  amount?: number | undefined | null,
  currency?: string | null,
  flipped?: boolean,
) => {
  if (!currency || typeof amount !== 'number') return '-';
  const amountStr = currencyNumberFormatter(amount, currency);
  const currencyStr = currency.toUpperCase();
  return flipped ? `${amountStr} ${currencyStr}` : `${currencyStr} ${amountStr}`;
};

export const currencyNumberFormatter = (amount: number, currency: string) => {
  return formattedCurrencyAmount(amount, currency);
};

export const intervalFormatter = (interval?: string | null, interval_count?: number | null) => {
  return interval_count && interval_count > 1 ? `${interval_count} ${interval}s` : interval;
};

// Take a Stripe price object and return the amount formatted as a string with the currency symbol
export const unitAmount = (price?: any, symbol?: string) => {
  return formattedCurrencyAmount(price.unit_amount, price.currency);
};

// Return the divisor for the currency to convert between 'cents' and 'dollars and cents'
// Most currencies are 100 cents to the dollar, but some just use 'cents' (Chilean Peso, Japanese Yen)
export const currencyUnitsDivisor = (currency: string) => {
  switch (currency.toLowerCase()) {
    case 'clp':
    case 'jpy':
      return 1;
    default:
      return 100;
  }
};

// Convert a currency amount in "cent equivalents" to the number in "dollars and cents" where the currency uses them
export const currencyAmount = (amount: number, currency: string) => {
  const divisor = currencyUnitsDivisor(currency);
  const decimals = divisor.toString().length - 1;
  return (amount / divisor).toFixed(decimals);
};

// Format a currency amount with the right number of decimal places and currency symbol
export const formattedCurrencyAmount = (amount: number, currency: string) => {
  switch (currency.toLowerCase()) {
    case 'chf':
      return `${currencyAmount(amount, currency)}`;
    default:
      return `${getSymbolFromCurrency(currency)}${currencyAmount(amount, currency)}`;
  }
};
